import type { Tone } from '@constants/tones';

const TEXT: Partial<Record<Tone, string>> = { green: 'text-green', amber: 'text-amber', critical: 'text-critical', blue: 'text-blue' };

/** Text colour class for a status tone (`fallback` for tones without one). */
export const toneTextClass = (tone: Tone, fallback = '') => TEXT[tone] ?? fallback;
